import { connect } from "redux-vue";
import * as commentsActions from "../actions/comments";
import * as commentActions from "../actions/comment";
import Comment from "./Comment";
import {orderOptions} from "../consts/commentsOrders";
import LoadingIndicator from "./LoadingIndicator";

const LIMIT = 10;

const Comments = {
  props: ['comments', 'fetchComments', 'module', 'comment', 'createComment', 'user'],

  data() {
    return {
      newComment: "",
      order: orderOptions[0].value,
      moreComments: false,
    }
  },

  mounted() {
    if (this.module) {
      this.fetchComments(this.module.id, this.order);
    }
  },

  methods: {
    /**
     *
     */
    handleCommentSubmit(e) {
      e.preventDefault();
      const comment = this.newComment;
      if (comment.length) {
        this.createComment(comment, this.module.id, this.user.model.id);
      }
    },

    /**
     *
     */
    onPressMoreComments() {
      this.moreComments = true;
    }
  },

  watch: {
    comment(nextVal, val) {
      if (val.create && !val.replyId && nextVal.createSuccess) {
        this.newComment = "";
      }
    },

    order(nextVal, val) {
      if (nextVal !== val) {
        this.fetchComments(this.module.id, this.order);
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    const loading = this.comments.fetch && <LoadingIndicator fill="black" class="mx-auto mb-10" />;

    const collection = this.moreComments ? this.comments.collection : this.comments.collection.slice(0, LIMIT);

    const comments = (
      <ul>
        {collection.map(i => (
          <li>
            <Comment modelProp={i} module={this.module} key={i.id} />
          </li>
        ))}
      </ul>
    );

    return (
      <div class="bg-white p-5">
        <h3 class="font-bold text-xl">
          {this.$t('course_page.discussion_board')}
        </h3>
        <div class="lg:pl-5">
          <div class="w-full lg:w-3/4 py-6 mb-10">
            <form>
              <textarea
                class="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-3"
                placeholder={this.$t('course_page.add_comment') + '...'} rows="5" disabled={this.comment.create} vModel={this.newComment}></textarea>
              <button
                class="flex-shrink-0 lg:mr-8 mb-3 lg:mb-0 p-2 px-5 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                type="submit" onClick={this.handleCommentSubmit} disabled={this.comment.create}>
                {this.comment.create && !this.comment.replyId && <LoadingIndicator />}
                {this.comment.create && !this.comment.replyId || (
                  <fragment>
                    {this.$t('course_page.add_comment')}
                    <i class="mdi mdi-arrow-right ml-3"></i>
                  </fragment>
                )}
              </button>
            </form>
          </div>

          <div class="flex justify-end items-center mb-10">
            <div class="text-base mr-3 font-bold">
              {this.$t('course_page.sort_by')}
            </div>
            <div class="relative">
              <select
                class="block appearance-none w-full bg-gray-200 text-sm border text-gray-700 p-2 pr-6 rounded leading-tight focus:outline-none focus:shadow-outline"
                v-model={this.order}
              >
                {orderOptions.map(i => (
                  <option value={i.value} key={i.value}>
                    {this.$t(i.label)}
                  </option>
                ))}
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <i class="mdi mdi-chevron-down"></i>
              </div>
            </div>
          </div>

          {loading}

          {comments}

          {this.comments.collection.length > LIMIT && !this.moreComments && (
            <button class="bg-blue-500 text-white p-1 w-full focus:outline-none flex lg:flex-row-reverse justify-center items-center" onClick={this.onPressMoreComments}>
              {this.$t('course_page.view_n_more_comments', {
                n: this.comments.collection.length -LIMIT
              })}
              <i class="mdi mdi-menu-down mx-1 text-3xl"></i>
            </button>
          )}

        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    comments: state.comments,
    comment: state.comment,
    user: state.user,
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchComments: (id, order) => dispatch(commentsActions.fetchComments(id, order)),
    createComment: (comment, link_id, user_id, reply_id) =>
      dispatch(commentActions.createComment(comment, link_id, user_id, reply_id)),
  }
}

export default connect(mapStateToProps, mapActionToProps)(Comments);
